import { buildUTCOffsetDateRange } from "@/utils/methods/calcDate"
import { Item, ObjectGeneric } from "../../../../../../../utils/types/generals"

const formatCompletingQuestionnaires = (payload: ObjectGeneric) => {

    let filters: any = []
    let shouldFilters: any = []

    if (payload?.from || payload?.to) {
        const { gte, lte } = buildUTCOffsetDateRange({
            from: payload?.from,
            to: payload?.to
        })
        const fieldName = payload?.intervale?.value == '1d' ? 'fecha_inicio' : 'fecha_inicio_semana'
        shouldFilters.push(
            {
                "range": {
                    [fieldName]: {
                        "gte": payload?.from ? gte : null,
                        "lte": payload?.to ? lte : null
                    }
                }
            },
            {
                "bool": {
                    "must_not": {
                        "exists": {
                            "field": fieldName
                        }
                    }
                }
            }
        )
    }

    if (payload?.roleIds && payload.roleIds.length > 0) {
        filters.push({
            "terms": {
                "role_id": payload.roleIds
            }
        })
    }

    if (!!payload?.units?.length) {
        filters.push({
            terms: {
                unidad_id: (payload?.units as Item[])?.map(item => item.value),
            },
        })
    }

    if (!!payload?.questionnaire?.length) {
        filters.push({
            terms: {
                cuestionario_id: (payload?.questionnaire as Item[])?.map(item => item.value),
            },
        })
    }

    const userIds = [
        ...(payload?.gerent?.length ? (payload.gerent as Item[]).map(item => item.value) : []),
        ...(payload?.supervisor?.length ? (payload.supervisor as Item[]).map(item => item.value) : []),
        ...(payload?.hierarchyUsers?.length ? (payload.hierarchyUsers as Item[]).map(item => item.value) : [])
    ]

    if (userIds.length > 0) {
        filters.push({
            terms: {
                usuario_id: userIds
            }
        })
    }

    const body = {
        "size": 0,
        "query": {
            "bool": {
                "must": filters,
                ...(shouldFilters.length > 0 && {
                    "should": shouldFilters,
                    "minimum_should_match": 1
                })
            }
        },
        "aggs": {
            "usuarios": {
                "terms": {
                    "field": "usuario_id",
                    "size": 1000,
                    "order": {
                        "_key": "asc"
                    }
                },
                "aggs": {
                    "ultimo_registro": {
                        "top_hits": {
                            "size": 1,
                            "sort": [
                                {
                                    "fecha": {
                                        "order": "desc"
                                    }
                                }
                            ],
                            "_source": [
                                "usuario",
                                "usuario_id",
                                "unidad",
                                "unidad_id",
                                "cuestionario",
                                "cuestionario_id",
                                "gerente_nombre",
                                "gerente_id",
                                "supervisor_nombre",
                                "supervisor_id",
                                "role_id",
                                "semana",
                            ]
                        }
                    },
                    "total_programado": {
                        "sum": {
                            "field": "cantidad_programada"
                        }
                    },
                    "total_no_ejecutado": {
                        "sum": {
                            "field": "no_ejecutado"
                        }
                    },
                    "total_finalizado": {
                        "sum": {
                            "field": "finalizado"
                        }
                    },
                    "promedio_resultado": {
                        "avg": {
                            "field": "resultado"
                        }
                    },
                    "ultima_fecha": {
                        "max": {
                            "field": "fecha"
                        }
                    }
                }
            },
            "totales_por_role": {
                "terms": {
                    "field": "role_id",
                    "size": 10
                },
                "aggs": {
                    "total_programado_role": {
                        "sum": {
                            "field": "cantidad_programada"
                        }
                    },
                    "total_no_ejecutado_role": {
                        "sum": {
                            "field": "no_ejecutado"
                        }
                    },
                    "total_finalizado_role": {
                        "sum": {
                            "field": "finalizado"
                        }
                    },
                    "promedio_resultado_role": {
                        "avg": {
                            "field": "resultado"
                        }
                    }
                }
            }
        }
    }

    return { body }
}

export { formatCompletingQuestionnaires }
